var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuixiang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 1.5,
    y: 0.5,
    width: 13,
    height: 15,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 551",
    d: "M5.50171 9.18681C5.50171 11.6851 6.75084 12.3096 7.99996 12.3096C9.24909 12.3096 10.4982 11.6851 10.4982 9.18681C10.4982 7.18821 8.62453 4.81487 7.99996 4.19031C7.3754 4.81487 5.50171 7.18821 5.50171 9.18681Z",
    fill: "#26A4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuixiang);
export default __webpack_public_path__ + "static/media/shuixiang.ac8e2bd917acb95f11d668ae23a935a8.svg";
export { ForwardRef as ReactComponent };